var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3334 14C23.3334 19.1547 19.1547 23.3334 14 23.3334C8.84538 23.3334 4.66671 19.1547 4.66671 14C4.66671 8.84538 8.84538 4.66671 14 4.66671C19.1547 4.66671 23.3334 8.84538 23.3334 14ZM25.6667 14C25.6667 20.4434 20.4434 25.6667 14 25.6667C7.55672 25.6667 2.33337 20.4434 2.33337 14C2.33337 7.55672 7.55672 2.33337 14 2.33337C20.4434 2.33337 25.6667 7.55672 25.6667 14ZM8.63771 18.5372C8.4099 18.3094 8.4099 17.9401 8.63771 17.7123L12.35 14L8.63771 10.2877C8.4099 10.0599 8.4099 9.69052 8.63771 9.46271L9.46267 8.63775C9.69047 8.40995 10.0598 8.40995 10.2876 8.63775L13.9999 12.3501L17.7122 8.63775C17.94 8.40995 18.3094 8.40995 18.5372 8.63775L19.3622 9.46271C19.59 9.69052 19.59 10.0599 19.3622 10.2877L15.6498 14L19.3622 17.7123C19.59 17.9401 19.59 18.3094 19.3622 18.5372L18.5372 19.3622C18.3094 19.59 17.94 19.59 17.7122 19.3622L13.9999 15.6499L10.2876 19.3622C10.0598 19.59 9.69047 19.59 9.46267 19.3622L8.63771 18.5372Z",
    fill: "#DD1D21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.65de83e0299343bef3a7d650e93ee5c9.svg";
export { ForwardRef as ReactComponent };